import { NoResultsFound } from "./NoResultsFound";
import { SearchResult } from "./SearchResult";

import type { FC } from "react";
import type { SearchResponse } from "~/api/generated-api";

type BadgeVariant =
  | "polish"
  | "math"
  | "english"
  | "7class"
  | "8class"
  | "8class-review"
  | null
  | undefined;

interface SearchResultsProps {
  phrase: string;
  results: SearchResponse["data"] | undefined;
  getBadgeVariant: (value: string) => BadgeVariant;
  handleCloseModal: (lessonId: string) => void;
  isLoading: boolean;
}

export const SearchResults: FC<SearchResultsProps> = ({
  phrase,
  results,
  getBadgeVariant,
  handleCloseModal,
  isLoading,
}) => {
  if (!results?.length && phrase.length >= 3 && !isLoading) return <NoResultsFound />;

  return (
    <>
      {results?.map((result) => (
        <SearchResult
          key={result.id}
          result={result}
          getBadgeVariant={getBadgeVariant}
          handleCloseModal={handleCloseModal}
        />
      ))}
    </>
  );
};
